import React from 'react';
import { BsGrid3X3 } from 'react-icons/bs';
import { FiBookmark, FiHeart, FiPlayCircle } from 'react-icons/fi';

export const TABS = [
    { id: 'posts', label: 'Posts', Icon: BsGrid3X3 },
    { id: 'top', label: 'Top', Icon: FiHeart },
    { id: 'viewed', label: 'Most viewed', Icon: FiPlayCircle },
    { id: 'saved', label: 'Saved', Icon: FiBookmark },
];

const ProfileTabs = ({ active, onChange }) => (
    <nav className="ig-tabs" role="tablist" aria-label="Sort posts">
        {TABS.map(({ id, label, Icon }) => (
            <button
                key={id}
                type="button"
                role="tab"
                aria-selected={active === id}
                aria-label={label}
                className={`ig-tab${active === id ? ' is-active' : ''}`}
                onClick={() => onChange(id)}
            >
                <Icon aria-hidden="true" />
                <span className="ig-tab-label">{label}</span>
            </button>
        ))}
    </nav>
);

export default ProfileTabs;
